export const appAddress =
  process.env.NODE_ENV === 'development'
    ? 'http://renewal.zena2d.com'
    : process.env.REACT_APP_ADDR || '';

export const version = {
  v1: 'v1',
};
